import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import BookingForm from "../components/BookingForm";
import BookingSummary from "../components/BookingSummary";
import AvailabilityCheck from "../components/AvailabilityCheck";

const BookingPage = () => {
  const location = useLocation();
  const editBooking = location.state?.booking;

  const [availabilityData, setAvailabilityData] = useState(null);
  const [previewData, setPreviewData] = useState(null);
  const [editBuffer, setEditBuffer] = useState(null); // ✅ NEW

  useEffect(() => {
    if (editBooking) {
      setAvailabilityData({
        hall: editBooking.Hall,
        eventDate: editBooking.EventDate,
      });
    }
  }, [editBooking]);

  return (
    <>
      {!availabilityData ? (
        <AvailabilityCheck onAvailable={setAvailabilityData} />
      ) : !previewData ? (
        <BookingForm
          onSubmit={setPreviewData}
          availabilityData={availabilityData}
          editData={editBuffer || editBooking} // ✅ FIX
        />
      ) : (
        <BookingSummary
          data={previewData}
          onEdit={() => {
            setEditBuffer(previewData); // ✅ store data
            setPreviewData(null);       // ✅ open form
          }}
          onReset={() => {
            setAvailabilityData(null);
            setPreviewData(null);
            setEditBuffer(null); // ✅ cleanup
          }}
        />
      )}
    </>
  );
};

export default BookingPage;